<template>
    <div>
        <v-layout mb-4 wrap justify-space-between
                  :class="{'px-3': $vuetify.breakpoint.xs}"
        >
            <v-flex xs12 md6>
                <inputIcon v-model="search_employee" class="layout row search--no-border icon-clickable"
                           icon_name="search" :placeholder="$t('Введите имя сотрудника...')"
                           @icon:click="updateSearchInput(search_employee)"
                />
            </v-flex>
            <v-flex lg3 md4 sm6
                    justify-end d-flex :class="{'mt-4': $vuetify.breakpoint.smAndDown,'pl-3': $vuetify.breakpoint.mdAndUp}"
            >
                <buttonBdWhite v-if="($vuetify.breakpoint.smAndDown && !showed_filter) || $vuetify.breakpoint.mdAndUp" @click.native="TOGGLE_FILTER()">{{ showed_filter ? $t('Скрыть фильтр') : $t('Показать фильтр') }}</buttonBdWhite>
            </v-flex>
        </v-layout>
        <v-layout v-if="showed_filter" sm12 xs12
                  mb-4 wrap
                  align-center
                  justify-space-between :class="{'px-3': $vuetify.breakpoint.xs}"
        >
            <v-layout :class="{'flex xs12 mb-4 display-block': $vuetify.breakpoint.sm}">
                <v-flex md4 sm12 xs12
                        mb-4
                        :class="{'mr-0': $vuetify.breakpoint.sm, 'mr-3': $vuetify.breakpoint.mdAndUp }"
                >
                    <v-layout column>
                        <div class="grey-text mb-3">{{ $t("Сотрудники организаций") }}</div>
                        <v-select
                            v-model="organizations_filtered"
                            :items="users_filters.organizations"
                            solo
                            append-icon=""
                            :label="$t('Выберите организацию')"
                            class="input"
                        >
                          <template #append>
                            <v-icon aria-hidden="true" translate="no">
                              expand_more
                            </v-icon>
                          </template>
                        </v-select>
                    </v-layout>
                </v-flex>
                <v-flex md4 sm12 xs12
                        mb-4
                >
                    <v-layout column>
                        <div class="grey-text mb-3">{{ $t("Роль в организации") }}</div>
                        <v-select
                            v-model="role_filtered"
                            :items="users_filters.roles"
                            solo
                            append-icon=""
                            :label="$t('Все роли')"
                            class="input"
                        >
                          <template #append>
                            <v-icon aria-hidden="true" translate="no">
                              expand_more
                            </v-icon>
                          </template>
                        </v-select>
                    </v-layout>
                </v-flex>
            </v-layout>
            <!-- <v-flex md3 sm5 xs12
                    class="mb-4"
            >
                <v-layout column>
                    <div class="grey-text mb-3">{{$t("Специализация")}}</div>
                    <v-select
                        v-model="speciality_filtered"
                        :items="users_filters.specializations"
                        solo
                        append-icon="expand_more"
                        :label="$t('Все специализации')"
                        class="input"
                    />
                </v-layout>
            </v-flex> -->
            <redLink sm12 xs12 ml-2
                     class="pr-3"
                     :class="{'flex xs12 mb-4': $vuetify.breakpoint.xs}" @click.prevent="reset_filters"
            >{{ $t("Сбросить фильтр") }}</redLink>
            <v-flex v-if="$vuetify.breakpoint.smAndDown" xs12 lg3
                    md4
                    sm6
                    justify-end d-flex
            > <buttonBdWhite @click.native="TOGGLE_FILTER()">{{ $t("Скрыть фильтр") }}</buttonBdWhite></v-flex>
        </v-layout>
        <dataTable :table="users_employees_table" :search="search_employee" type="employees"
                   :filter="obj"
        />
        <v-layout align-center wrap :class="{'px-3 justify-center': $vuetify.breakpoint.xs, 'mt-4': $vuetify.breakpoint.smAndDown, 'mt-5 justify-end': $vuetify.breakpoint.mdAndUp}">
            <v-flex><buttonRed :class="{'flex xs12 my-4': $vuetify.breakpoint.xs}" @click.native="OPEN_MODAL('add_user')">{{ $t("Добавить пользователя") }}</buttonRed></v-flex>
            <v-flex md5 sm7 xs12>
                <div class="text-xs-center">
                    <v-pagination
                        v-model="pagination"
                        :length="users_pages"
                        :total-visible="$vuetify.breakpoint.xs ? 4 : 6"
                        prev-icon="arrow_back_ios"
                        next-icon="arrow_forward_ios"
                    />
                </div>
            </v-flex>
            <v-flex md4 sm6 xs12
                    :class="{'flex xs12': $vuetify.breakpoint.xs, 'mt-4': $vuetify.breakpoint.smAndDown}"
            >
                <v-select
                    v-model="paginationTitle"
                    :items="$vuetify.breakpoint.mdAndUp ? [$t('Показывать по 10'),$t('Показывать по 25'),$t('Показывать по 50'),$t('Показывать по 100')]
                    : [$t('Показывать по 10'),$t('Показывать по 25'),$t('Показывать по 50')]"
                    solo
                    append-icon=""
                    :label="$t('Показывать по 10')"
                    class="input"
                >
                  <template #append>
                    <v-icon aria-hidden="true" translate="no">
                      expand_more
                    </v-icon>
                  </template>
                </v-select>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import buttonBdWhite from '@/components/ui/buttons/button_bd_white';
import inputIcon   from '@/components/ui/inputs/typed/input_icon';
import redLink from '@/components/ui/links/styled/link_red';
import dataTable from '../Users_table';
import buttonRed   from '@/components/ui/buttons/button_red';
import {mapGetters, mapMutations, mapActions} from 'vuex';
export default {
  components: {
    dataTable,
    buttonRed,
    redLink,
    inputIcon,
    buttonBdWhite,
  },
  data() {
    return {
      paginationTitles: {
        '10' : 'Показывать по 10',
        '25' : 'Показывать по 25',
        '50' : 'Показывать по 50',
        '100': 'Показывать по 100',
      },
      obj: {
        page_size   : '25',
        page_num    : '',
        organization: '',
        role        : '',
        spec        : '',
        name        : '',
      },
    };
  },
  computed: {
    paginationTitle: {
      get() {
        return this.paginationTitles[this.obj.page_size];
      },
      set($event) {
        const pagination = Number($event.slice(-3));
        this.obj.page_size = pagination;
        localStorage.setItem('paginationValueUsers', pagination);
        this.SHOW_NUMBER($event);
        this.get_users(this.obj);

        return this.paginationTitles[this.obj.page_size];
      },
    },
    ...mapGetters('users', [
      'tab',
      'showed_filter',
    ]),
    ...mapGetters('users/modals', [
      'add_user',
      'add_organization',
    ]),
    ...mapGetters('users/employees', [
      'users_employees_table',
      'users_filters',
      'org_filter',
      'role_filter',
      'speciality_filter',
      'users_pages',
      'page',
      'search_string',
    ]),
    pagination: {
      get() {
        return this.page;
      },
      set($event) {
        this.SET_PAGE($event);
        this.obj.page_num = $event;
        this.get_users(this.obj);
        return;
      },
    },
    search_employee: {
      get() {
        return this.search_string;
      },
      set($event) {
        return this.updateSearchInput($event.target.value);
      },
    },
    organizations_filtered: {
      get() {
        return this.org_filter;
      },
      set($event) {
        this.SET_ORG_FILTER($event);
        this.obj.organization = this.users_filters.organizations.find((item)=>{
          return item.text == $event;
        }).id;
        this.get_users(this.obj);
        return;
      },
    },
    role_filtered: {
      get() {
        return this.role_filter;
      },
      set($event) {
        this.SET_ROLE_FILTER($event);
        this.obj.role = this.users_filters.roles.find((item)=>{
          return item.text == $event;
        }).id;
        this.get_users(this.obj);
        return;
      },
    },
    speciality_filtered: {
      get() {
        return this.speciality_filter;
      },
      set($event) {
        this.SET_SPECIALITY_FILTER($event);
        this.obj.spec = this.users_filters.specializations.find((item)=>{
          return item.text == $event;
        }).id;
        this.get_users(this.obj);
        return;
      },
    },
  },
  async mounted() {
    this.obj.page_size = localStorage.getItem('paginationValueUsers') || 10;
    await this.update_users(Object.assign(this.obj, {organization: this.$route.query.filter_org}));
  },
  methods: {
    ...mapMutations('users', [
      'SET_ACTIVE_TAB',
      'TOGGLE_FILTER',
    ]),
    ...mapMutations('users/employees', [
      'SET_PAGE',
      'SHOW_NUMBER',
      'SEARCH_EMPLOYEE',
      'SET_ORG_FILTER',
      'SET_ROLE_FILTER',
      'SET_SPECIALITY_FILTER',
      'RESET_EMPLOYEES_FILTERES',
    ]),
    ...mapMutations('users/modals', [
      'OPEN_MODAL',
      'CLOSE_MODAL',
    ]),
    ...mapActions('users/employees', [
      'get_users',
      'update_users',
    ]),
    // set_page_size($event) {
    //   const pagination = Number($event.slice(-3));
    //   this.obj.page_size = pagination;
    //   localStorage.setItem('paginationValueUsers', pagination);
    //   this.SHOW_NUMBER($event);
    //   this.get_users(this.obj);
    // },
    updateSearchInput(value) {
      this.SEARCH_EMPLOYEE(value);
      this.obj.name = value;
      this.get_users(this.obj);
    },
    reset_filters() {
      this.$router.replace({name: 'users'});
      this.obj.organization='';
      this.obj.role ='';
      this.obj.spec ='';
      this.updateSearchInput('');
      this.get_users(this.obj);
      this.RESET_EMPLOYEES_FILTERES();
    },
  },
};
</script>
